import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Container, Typography, Box, Paper, Grid } from '@mui/material';
const API_URL = process.env.REACT_APP_API_URL || '';

const Dashboard = () => {
    const [dashboardData, setDashboardData] = useState(null);
    const token = localStorage.getItem('token');

    useEffect(() => {
        const fetchDashboard = async () => {
            try {
                const response = await axios.get(`${API_URL}/api/dashboard`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setDashboardData(response.data);
            } catch (error) {
                console.error('Błąd pobierania danych dashboard:', error);
            }
        };
        fetchDashboard();
    }, [token]);

    return (
        <Container maxWidth="lg">
            <Box sx={{ mt: 4 }}>
                <Typography variant="h4" gutterBottom>Dashboard</Typography>
                {dashboardData ? (
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <Paper elevation={3} sx={{ p: 2 }}>
                                <Typography variant="h6">Aktywni Klienci</Typography>
                                <Typography variant="h4">{dashboardData.activeClients.length}</Typography>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Paper elevation={3} sx={{ p: 2 }}>
                                <Typography variant="h6">Oczekujące Zadania</Typography>
                                <Typography variant="h4">{dashboardData.pendingTasks}</Typography>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Paper elevation={3} sx={{ p: 2 }}>
                                <Typography variant="h6">Dzisiejsze Spotkania</Typography>
                                <Typography variant="h4">{dashboardData.todayMeetings}</Typography>
                            </Paper>
                        </Grid>
                        <Grid item xs={12}>
                            <Paper elevation={3} sx={{ p: 2 }}>
                                <Typography variant="h6" gutterBottom>Ostatnie Alerty</Typography>
                                {dashboardData.recentAlerts.length > 0 ? (
                                    dashboardData.recentAlerts.map(alert => (
                                        <Box key={alert.id} sx={{ mb: 1 }} bgcolor={alert.severity === 'high' ? 'error.light' : ''} borderRadius={2} p={1}>
                                            <Typography variant="body1" color={alert.severity === 'high' ? '#fff' : ''}>{alert.message || alert.description}</Typography>
                                            <Typography variant="caption" color={alert.severity === 'high' ? '#fff' : ''}>{new Date(alert.created_at).toLocaleString()}</Typography>
                                        </Box>
                                    ))
                                ) : (
                                    <Typography variant="body1">Brak alertów</Typography>
                                )}
                            </Paper>
                        </Grid>
                    </Grid>
                ) : (
                    <Typography variant="body1">Ładowanie danych...</Typography>
                )
                }
            </Box >
        </Container >
    );
};

export default Dashboard;